import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
    listingsWaitingForApprove: {},
    listingWaitingData:[],
    rejectStatus: {},
    renewStatus: {},
    deleteStatus: {},
    listing: null,
}

const getters = {
    listingsWaitingForApprove: (state) => state.listingsWaitingForApprove,
    renewStatus: (state) => state.renewStatus,
    rejectStatus: (state) => state.rejectStatus,
    deleteStatus: (state) => state.deleteStatus,
    listing: (state) => state.listing,
    listingWaitingData: (state) => state.listingWaitingData
};

const actions = {
    [actionType.GET_LISTINGS_WAITING_FOR_APPROVE]: async function ({ commit }, params) {
        let data = {
            take: params.take || -1,
            page: params.page || 1,
            fillter: params.fillter || 'All',
            sort_by: params.sort_by || 'MostRelevant',
        }
        if(typeof params.search !== 'undefined' && params.search !== ''){
            data.search = params.search
        }
        return new Promise((resolve, reject) => {
            api.get('/admin/listings/waiting-for-approve', {
                params: data,
            }).then(result => { 
                resolve(result.data.data.listings);
                let response = {
                    page:result.data.meta.page,
                    data:result.data.data.listings
                }
                commit(mutationType.SET_LISTINGS_WAITING_DATA, response)
                commit(mutationType.SET_LISTINGS_WAITING_FOR_APPROVE, {
                     data: result.data.data,
                })
                
            })
                .catch(error => reject(error));
        });
    },
    [actionType.ADMIN_RENEW_LISTING]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/listings/renew/${params.id}`).then(result => {
                commit(mutationType.SET_ADMIN_RENEW_LISTING_STATUS, {
                    data: result.data,
                })
            })
                .catch(error => reject(error));
        });
    },
    [actionType.ADMIN_REJECT_LISTING]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/listings/reject/${params.id}`, {
                comment: params.comment
            }).then(result => {
                commit(mutationType.SET_ADMIN_REJECT_LISTING_STATUS, {
                    data: result.data,
                })
            })
                .catch(error => reject(error));
        });
    },
    [actionType.ADMIN_DELETE_LISTING]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.delete(`/admin/listings/${params.id}`).then(result => {
                commit(mutationType.SET_ADMIN_REJECT_LISTING_STATUS, {
                    data: result.data,
                })
            })
                .catch(error => reject(error));
        });
    },
    [actionType.ADMIN_GET_LISTING_DETAIL]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`admin/listings/preview/${params.id}`).then(result => {
                commit(mutationType.SET_ADMIN_GET_LISTING_DETAIL, {
                    data: result.data.data,
                })
            })
                .catch(error => reject(error));
        });
    },
    [actionType.ADMIN_APPROVE_LISTING]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/listings/approve/${params.id}`).then(result => {
                resolve(result.data)
            })
                .catch(error => reject(error));
        });
    },
    "ADMIN_SUSPEND_LISTING": async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/listings/suspend/${params.id}`).then(result => {
                resolve(result)
            })
                .catch(error => reject(error));
        });
    },
    [actionType.ADMIN_APPROVE_COUNT_LISTING]: async function ({ commit }, fillter) {
        return new Promise((resolve, reject) => {
            api.get("/admin/listings/count-listings-on-approve-page", {
                params: {
                    fillter: fillter
                }
            }).then(result => {
                resolve(result.data)
            })
                .catch(error => reject(error));
        });
    },
    
}

const mutations = {
    [mutationType.SET_LISTINGS_WAITING_FOR_APPROVE]: function (state, data) {
        state.listingsWaitingForApprove = data.data;
    },
    [mutationType.SET_ADMIN_RENEW_LISTING_STATUS]: function (state, data) {
        state.renewStatus = data.data;
    },
    [mutationType.SET_ADMIN_REJECT_LISTING_STATUS]: function (state, data) {
        state.rejectStatus = data.data;
    },
    [mutationType.SET_ADMIN_DELETE_LISTING_STATUS]: function (state, data) {
        state.deleteStatus = data.data;
    },
    [mutationType.SET_ADMIN_GET_LISTING_DETAIL]: function (state, data) {
        state.listing = data.data;
    },
    [mutationType.SET_LISTINGS_WAITING_DATA]: function (state, data) {
       if(data.page == 1 )
       {
            state.listingWaitingData = data.data
       }
       else{
            state.listingWaitingData = state.listingWaitingData.concat(data.data);
       }
    },
    "RESET_LISTINGS_WAITING_DATA": function (state, data) {
             state.listingWaitingData = []
     },
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

